import request from '../untils/request';

export const materialLibraryCreateApi = params => {
  return request({
    url: '/common/material-library/register',
    params,
  });
};

export const materialLibraryListApi = params => {
  return request({
    url: '/common/material-library/index',
    params,
  });
};
